export function getMilliSecondsFromDays(days: number): number {
  return (days || 0) * 24 * 60 * 60 * 1000
}

export function getDaysFromMilliseconds(ms: number): number {
  return Math.round((ms || 0) / 1000 / 60 / 60 / 24)
}

export function getMillisecondsFromHours(hours: number): number {
  return (hours || 0) * 60 * 60 * 1000
}

export function getHoursFromMilliseconds(ms: number): number {
  return (ms || 0) / 1000 / 60 / 60
}

export function getMillisecondsFromMinutes(minutes: number): number {
  return (minutes || 0) * 60 * 1000
}

export function getMinutesFromMilliseconds(ms: number): number {
  return Math.round((ms || 0) / 1000 / 60)
}
